import { render, staticRenderFns } from "./MainOnlineEdu.vue?vue&type=template&id=f874a2e0&scoped=true&"
import script from "./MainOnlineEdu.vue?vue&type=script&lang=js&"
export * from "./MainOnlineEdu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f874a2e0",
  null
  
)

export default component.exports